import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import api from '../services/api';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export default function Escala() {
  const [horarios, setHorarios] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [datasIndisponiveis, setDatasIndisponiveis] = useState('');
  const datasRef = useRef(null);
  const prevRawRef = useRef('');
  const prevLenRef = useRef(0);
  const [selecionados, setSelecionados] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [coordenador, setCoordenador] = useState(null);
  const [modalVisivel, setModalVisivel] = useState(false);
  const [escalaBloqueada, setEscalaBloqueada] = useState(false);
  const [mensagemBloqueio, setMensagemBloqueio] = useState('');
  const token = localStorage.getItem('token');
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  })();
  const mesAtual = new Date().toISOString().slice(0, 7);
  const [mesReferencia] = useState(mesAtual);
  const navigate = useNavigate();
  const location = useLocation();
  const { paroquiaSlug: paroquia, comunidadeSlug: comunidade, tipoSlug: tipo } = useParams();
  const { dioceseSlug, paroquiaSlug, comunidadeSlug, tipoSlug } = useParams();
  // grupoMap com useMemo para evitar warning
  const grupoMap = useMemo(() => ({ coroinha: 2, acolito: 5 }), []);
  // Extrai grupo_id da query string
  const searchParams = new URLSearchParams(location.search);
  const grupoIdFromUrl = searchParams.get('grupo_id');


  // Busca perfil do grupo da rota se for admin e grupo_id válido, senão busca o próprio perfil
  const formatErr = (err) => {
    if (!err) return '';
    if (typeof err === 'string') return err;
    if (err.response && err.response.data) {
      const v = err.response.data.error ?? err.response.data;
      if (typeof v === 'string') return v;
      if (v && v.message) return String(v.message);
      try { return JSON.stringify(v); } catch { /* fallthrough */ }
    }
    if (err.message) return String(err.message);
    try { return JSON.stringify(err); } catch { return String(err); }
  };
  useEffect(() => {
    async function fetchUser() {
      if (!token || !user) return;
      const roles = (user.roles || []).map(r => r.toLowerCase());
      // Se for admin E grupoIdFromUrl válido, busca coordenador do grupo
      if (roles.includes('admin') && grupoIdFromUrl && grupoIdFromUrl !== 'undefined' && grupoIdFromUrl !== '') {
        try {
          const res = await api.get(`/auth/me?grupo_id=${grupoIdFromUrl}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setCoordenador(res.data);
          setError(null);
        } catch (err) {
          if (err.response && err.response.status === 404) {
            setError('Coordenador não encontrado para o grupo informado.');
            setCoordenador(null);
          } else {
            setError('Erro ao buscar coordenador.');
            setCoordenador(null);
          }
        }
      } else {
        // Se for coordenador, busca /auth/me normalmente
        if (roles.includes('coordenador')) {
          if (!user._fetched) {
            try {
              const res = await api.get('/auth/me', {
                headers: { Authorization: `Bearer ${token}` },
              });
              // Marca que já buscou
              localStorage.setItem('user', JSON.stringify({ ...res.data, _fetched: true }));
              setError(null);
            } catch (err) {
              setError('Erro ao buscar usuário.');
            }
          }
        }
      }
    }
    if (token && user) {
      const roles = (user.roles || []).map(r => r.toLowerCase());
      if (roles.includes('admin') && grupoIdFromUrl && grupoIdFromUrl !== 'undefined' && grupoIdFromUrl !== '') {
        fetchUser();
      } else if (roles.includes('admin')) {
        // Se for admin mas não tem grupo_id na URL, não busca outro grupo, usa o próprio perfil
        setCoordenador(null);
      } else if (roles.includes('coordenador')) {
        fetchUser();
      }
    }
  }, [token, grupoIdFromUrl, user, setCoordenador]);

  // Prioriza coordenador se buscado, senão usa usuário logado
  const usuarioPainel = coordenador || user;

  // Renderização condicional só depois dos hooks


  const carregarHorarios = useCallback(async () => {
    if (!paroquia || !comunidade) {
      setError("Não foi possível identificar a paróquia ou comunidade a partir da URL.");
      return;
    }
    try {
      const url = `/horarios/${paroquia}/${comunidade}/${tipo}`;
      const res = await api.get(url);
      setHorarios(res.data.horarios || {});
      setEscalaBloqueada(res.data.bloqueado || false);
      setMensagemBloqueio(res.data.mensagem || '');
    } catch (err) {
      // erro já tratado abaixo
      setError('Falha ao buscar os horários. Tente recarregar a página.');
    }
  }, [paroquia, comunidade, tipo]);

  useEffect(() => {
    const loadPageData = async () => {
      setLoading(true);
      setError(null);
      await carregarHorarios();
      setLoading(false);
    };
    loadPageData();
  }, [carregarHorarios]);

  // Renderização condicional após todos os hooks
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
        <div className="bg-white p-8 rounded-xl shadow text-center max-w-md">
          <h2 className="text-2xl font-bold text-red-600 mb-2">Erro</h2>
          <p className="text-gray-700 mb-6">{error}</p>
          <button
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto px-6 py-3 bg-green-600 text-white rounded-lg font-semibold shadow hover:bg-green-700 transition-colors flex items-center justify-center"
          >
            <span className="inline-block align-middle mr-2 text-xl" style={{ verticalAlign: 'middle', minWidth: '20px' }}>←</span>
            Voltar para Home
          </button>
        </div>
      </div>
    );
  }
  if (loading || (token && !usuarioPainel)) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <p className="text-xl text-slate-500">Carregando dados do usuário...</p>
      </div>
    );
  }

  const handleChange = (dia, horarioId) => {
    if (escalaBloqueada) return;
    setSelecionados((prev) => {
      const anteriores = prev[dia] || [];
      const novaSelecao = anteriores.includes(horarioId)
        ? anteriores.filter((id) => id !== horarioId)
        : [...anteriores, horarioId];
      if (novaSelecao.length === 0) {
        const { [dia]: _, ...resto } = prev;
        return resto;
      }
      return { ...prev, [dia]: novaSelecao };
    });
  };

  const formatDateDigits = (digits) => {
    const d = (digits || '').replace(/\D/g, '').slice(0, 8);
    const dd = d.slice(0, 2);
    const mm = d.slice(2, 4);
    const yyyy = d.slice(4, 8);
    if (d.length <= 2) return dd;
    if (d.length <= 4) return `${dd}/${mm}`;
    return `${dd}/${mm}/${yyyy}`;
  };

  // helpers for formatting kept minimal; caret mapping removed to let browser manage selection

  // Formata entrada de datas (DD/MM/AAAA) conforme o usuário digita e pula para próxima linha ao completar
  const handleDatasChange = (e) => {
    const el = e.target;
    const raw = el.value;
    const selStart = el.selectionStart ?? raw.length;

    // índice de dígitos antes do cursor not needed when letting browser manage caret

    const rawLines = raw.split('\n');
    const formattedLines = rawLines.map((line) => {
      const digits = line.replace(/\D/g, '').slice(0, 8);
      return formatDateDigits(digits);
    });

    let result = formattedLines.join('\n');

    // Pula para próxima linha somente quando a última linha estiver completa e o cursor estiver no fim
    const lastRawLine = rawLines.length ? rawLines[rawLines.length - 1] : '';
    const lastDigits = lastRawLine.replace(/\D/g, '').slice(0, 8);
    const isCaretAtEnd = selStart === raw.length;
    if (isCaretAtEnd && lastDigits.length === 8) {
      if (!result.endsWith('\n')) result += '\n';
    }

    // We intentionally do not programmatically move the caret here; browser will preserve it.

    // Atualiza valor formatado. Não mexemos na seleção do textarea aqui —
    // manter o caret gerenciado pelo navegador evita saltos inesperados
    // em sequência de deleções/reescritas.
    setDatasIndisponiveis(result);
    // atualiza refs de estado anterior para uso em heurísticas posteriores
    prevRawRef.current = raw;
    prevLenRef.current = raw.length;
  };

  const handleDatasKeyDown = (e) => {
    // Permite atalhos (Ctrl/Cmd) e navegação
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    // Se estiver digitando número, mantém a digitação no final.
    // Importante: NÃO mexer no cursor quando houver seleção (Ctrl+A) ou quando for apagar,
    // senão o usuário não consegue limpar o campo corretamente.
    if (/^\d$/.test(e.key)) {
      const el = e.target;
      if (el && typeof el.value === 'string') {
        const end = el.value.length;
        const selStart = el.selectionStart ?? end;
        const selEnd = el.selectionEnd ?? end;
        const hasSelection = selStart !== selEnd;
        if (!hasSelection && selStart !== end) {
          try {
            el.setSelectionRange(end, end);
          } catch {
            // ignore
          }
        }
      }
    }

    const allowed = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End', 'Tab', 'Enter'
    ];
    if (allowed.includes(e.key)) return;
    // Só permite dígitos
    if (/^\d$/.test(e.key)) return;
    // Bloqueia espaço, barras e qualquer outro caractere
    e.preventDefault();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    if (!usuarioPainel || !usuarioPainel.paroquia_id || !usuarioPainel.comunidade_id || !usuarioPainel.grupo_id) {
      setError("Seu perfil está incompleto. Não foi possível identificar paróquia, comunidade ou grupo.");
      setIsSubmitting(false);
      return;
    }

    // Validação: cada linha deve estar no formato DD/MM/AAAA e corresponder a uma data válida
    const linhas = datasIndisponiveis.split('\n').map(l => l.trim()).filter(Boolean);
    const invalidLines = [];
    const datasFormatadas = [];
    for (let i = 0; i < linhas.length; i++) {
      const dataStr = linhas[i];
      const m = dataStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!m) {
        invalidLines.push({ line: i + 1, value: dataStr, reason: 'Formato inválido' });
        continue;
      }
      const dia = Number(m[1]);
      const mes = Number(m[2]);
      const ano = Number(m[3]);
      // Verifica limites básicos
      if (mes < 1 || mes > 12 || dia < 1 || dia > 31) {
        invalidLines.push({ line: i + 1, value: dataStr, reason: 'Dia ou mês fora de intervalo' });
        continue;
      }
      // Verifica validade real da data
      const dt = new Date(`${ano}-${String(mes).padStart(2,'0')}-${String(dia).padStart(2,'0')}T00:00:00Z`);
      if (isNaN(dt.getTime()) || dt.getUTCFullYear() !== ano || (dt.getUTCMonth() + 1) !== mes || dt.getUTCDate() !== dia) {
        invalidLines.push({ line: i + 1, value: dataStr, reason: 'Data inválida' });
        continue;
      }
      datasFormatadas.push(`${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`);
    }
    if (invalidLines.length > 0) {
      setError(`Datas inválidas nas linhas: ${invalidLines.map(x => x.line).join(', ')}. Use o formato DD/MM/AAAA.`);
      setIsSubmitting(false);
      return;
    }

    const payload = {
      paroquia_id: usuarioPainel.paroquia_id,
      comunidade_id: usuarioPainel.comunidade_id,
      grupo_id: usuarioPainel.grupo_id,
      horarios_disponiveis: selecionados,
      datas_indisponiveis: datasFormatadas,
      mes_referencia: mesReferencia
    };

    try {
      await api.post('/escala/processar', payload);
      setModalVisivel(true);
    } catch (err) {
      // normaliza erro para string antes de renderizar
      setError(formatErr(err) || 'Ocorreu um erro ao enviar sua disponibilidade.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setModalVisivel(false);
    navigate(`/diocese/${dioceseSlug}/paroquia/${paroquiaSlug}/comunidade/${comunidadeSlug}/tipo/${tipoSlug}`);
  };



  return (
    <>
      {modalVisivel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-2xl max-w-sm w-full mx-4 text-center">
            <h2 className="text-2xl font-bold text-green-600 mb-4">Concluído!</h2>
            <p className="text-gray-700 mb-6">Sua disponibilidade foi enviada com sucesso para processamento.</p>
            <button
              onClick={handleCloseModal}
              className="bg-green-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-green-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Ok
            </button>
          </div>
        </div>
      )}

      <div className="max-w-3xl mx-auto p-4 sm:p-6 md:p-8">
        {/* Banner informativo se admin/coordenador está agindo como outro grupo */}
        {(() => {
          if (user && usuarioPainel) {
            const rolesUser = (user.roles || []).map(r => r.toLowerCase());
            const isAdminOrCoord = rolesUser.includes('admin') || rolesUser.includes('coordenador');
            let grupoIdBanner = null;
            if (tipoSlug && grupoMap[tipoSlug]) grupoIdBanner = grupoMap[tipoSlug];
            if (isAdminOrCoord && grupoIdBanner && usuarioPainel.grupo_id === grupoIdBanner && usuarioPainel.id !== user.id) {
              return (
                <div className="mb-4 p-3 bg-blue-100 border-l-4 border-blue-500 text-blue-800 rounded shadow">
                  <strong>Aviso:</strong> Você está gerenciando como <b>{usuarioPainel.name}</b> ({usuarioPainel.tipo})
                </div>
              );
            }
          }
          return null;
        })()}
        <div className="text-center mb-6">
          <div className="flex justify-center mb-6">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-green-600 text-green-700 font-semibold rounded-full shadow hover:bg-green-50 hover:text-green-800 transition-colors focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2 text-base"
              style={{ minWidth: 220 }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
              Voltar para Home
            </button>
          </div>
          <h1 className="text-3xl font-bold text-gray-800">Preencher Disponibilidade</h1>
          <p className="text-lg text-gray-500 mt-1">Selecione os horários fixos em que pode servir.</p>
        </div>

        {escalaBloqueada && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 mb-6 rounded-md shadow" role="alert">
            <p className="font-bold">Período de Preenchimento Encerrado</p>
            <p>{mensagemBloqueio || 'O preenchimento da escala não está disponível no momento.'}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Campo de mês de referência oculto */}
          <input type="hidden" value={mesReferencia} name="mes_referencia" />
          {(() => {
            if (Object.keys(horarios).length === 0 && !loading) {
              return (
                <div className="text-center p-10 bg-white rounded-lg shadow-sm">
                  <h2 className="font-bold text-xl">Nenhum Horário Cadastrado</h2>
                  <p className="text-gray-600 mt-2">Não há horários fixos disponíveis para seleção nesta comunidade.</p>
                </div>
              );
            }
            // Se admin, mostra todos os horários; senão, filtra pelo grupo
            const rolesUser = (user?.roles || []).map(r => r.toLowerCase());
            const isAdmin = rolesUser.includes('admin');
            let horariosParaListar;
            if (isAdmin) {
              horariosParaListar = Object.entries(horarios).filter(([dia, lista]) => Array.isArray(lista) && lista.length > 0);
            } else {
              let grupoIdParaFiltrar = usuarioPainel?.grupo_id;
              horariosParaListar = Object.entries(horarios).filter(([dia, lista]) => {
                return Array.isArray(lista) && grupoIdParaFiltrar && lista.some(h => h.grupo_id === grupoIdParaFiltrar);
              });
            }
            const temHorariosDisponiveis = horariosParaListar.length > 0;
            if (!temHorariosDisponiveis) {
              return (
                <div className="text-center p-10 bg-white rounded-lg shadow-sm">
                  <h2 className="font-bold text-xl">Nenhum Horário para este Grupo</h2>
                  <p className="text-gray-600 mt-2">Não há horários fixos disponíveis para este grupo nesta comunidade.</p>
                </div>
              );
            }
            return horariosParaListar.map(([dia, lista]) => (
              <div key={dia} className="p-5 border rounded-xl shadow-sm bg-white">
                <h3 className="font-semibold capitalize text-xl border-b pb-3 mb-4 text-gray-700">{dia.replace('-', ' ')}</h3>
                <div className="space-y-3">
                  {(isAdmin ? lista : lista.filter(h => h.grupo_id === usuarioPainel?.grupo_id))
                    .filter(h => h.ativo)
                    .map((h) => (
                      <div key={h.id} className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          id={`${dia}-${h.id}`}
                          checked={selecionados[dia]?.includes(h.id) || false}
                          onChange={() => handleChange(dia, h.id)}
                          disabled={escalaBloqueada}
                          className="h-5 w-5 rounded border-gray-300 text-green-600 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        />
                        <label htmlFor={`${dia}-${h.id}`} className={`text-gray-700 ${escalaBloqueada ? 'text-gray-400' : ''}`}>{h.hora} - {h.rotulo}</label>
                      </div>
                    ))}
                </div>
              </div>
            ));
          })()}

          {(() => {
            const temHorariosDisponiveis = Object.entries(horarios).some(([dia, lista]) => {
              return Array.isArray(lista) && usuarioPainel &&
                lista.some(h => h.grupo_id === usuarioPainel.grupo_id);
            });
            return (
              <div className="bg-white p-5 border rounded-xl shadow-sm">
                <label htmlFor="datas_indisponiveis" className="block mb-2 font-medium text-gray-700">Datas específicas que NÃO pode servir (uma por linha, formato DD/MM/AAAA):</label>
                <textarea
                  id="datas_indisponiveis"
                  ref={datasRef}
                  rows={4}
                  className="w-full border rounded-lg p-3 border-gray-300 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
                  value={datasIndisponiveis}
                  onFocus={(e) => {
                    const el = e.target;
                    const end = el.value.length;
                    try {
                      el.setSelectionRange(end, end);
                    } catch {
                      // ignore
                    }
                  }}
                  onKeyDown={handleDatasKeyDown}
                  onChange={handleDatasChange}
                  placeholder="Ex: 25/12/2025&#10;01/01/2026"
                  disabled={escalaBloqueada || !temHorariosDisponiveis}
                ></textarea>
                {!temHorariosDisponiveis && (
                  <p className="text-sm text-gray-500 mt-2">Campo desabilitado: não há horários disponíveis para seu grupo.</p>
                )}
              </div>
            );
          })()}

          {(() => {
            const temHorariosDisponiveis = Object.entries(horarios).some(([dia, lista]) => {
              return Array.isArray(lista) && usuarioPainel &&
                lista.some(h => h.grupo_id === usuarioPainel.grupo_id);
            });
            return (
              <button
                type="submit"
                disabled={isSubmitting || loading || escalaBloqueada || !temHorariosDisponiveis}
                className="w-full bg-green-600 text-white px-4 py-3 rounded-lg font-semibold text-lg hover:bg-green-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {escalaBloqueada ? 'Preenchimento Encerrado' :
                  !temHorariosDisponiveis ? 'Nenhum Horário Disponível' :
                    (isSubmitting ? 'Enviando...' : 'Enviar Disponibilidade')}
              </button>
            );
          })()}
        </form>
      </div>
    </>
  );
}